import { render } from "./ProductDetailsVideo.vue?vue&type=template&id=59fe8fa7&scoped=true"
import script from "./ProductDetailsVideo.vue?vue&type=script&lang=js"
export * from "./ProductDetailsVideo.vue?vue&type=script&lang=js"

import "./ProductDetailsVideo.vue?vue&type=style&index=0&id=59fe8fa7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fe8fa7"]])

export default __exports__